import { FC } from "react";
import { Typography } from "@mui/material";
import trans from "helpers/trans";

const NotFound: FC = () => {
    return <Typography>{trans("inv.app.page.notFound.text")}</Typography>;
};

export default NotFound;
